export default __webpack_public_path__ + "static/media/crwhl.6178deeb.jfif";